import { t } from "i18next";
import { useState } from "react";
import { countTimeExpired } from "../../Services/service";

export default function PaymentPolicyInfo() {
    const [objectDto, setObjectDto] = useState(
        {
            premium: "", poName: "PHẠM THỊ BẮC",
            policyStatusStr: "Đang hiệu lực",
            poPhone: "1111111111", email: "",
            poAddress: "Quỳnh Tân 2, Thị trấn Buôn Trấp, Huyện Krông A Na, Tỉnh Đắk Lắk",
        });
    countTimeExpired(objectDto, setObjectDto);
    return (
        <div className="col-md-12 col-sm-12 col-xs-12 form-group " id="payment-policy-info">
            <fieldset className="agent-information">
                <div className="form-group col-md-12">
                    <label className="col-md-2">
                        {t("policyowner")}
                    </label>
                    <div className="col-md-4">
                        <label className="form-control form-detail" >{objectDto.poName}</label>
                    </div>
                    <label className="col-md-2">
                        {t("policystatus")}
                    </label>
                    <div className="col-md-4">
                        <label className="form-control form-detail" >{objectDto.policyStatusStr}</label>
                    </div>
                </div>
                <div className="form-group col-md-12">
                    <label className="col-md-2">
                        {t("phone")}
                    </label>
                    <div className="col-md-4">
                        <label className="form-control form-detail">{objectDto.poPhone}</label>
                    </div>
                    <label className="col-md-2">
                        {t("email")}
                    </label>
                    <div className="col-md-4">
                        <label className="form-control form-detail">{objectDto.email}</label>
                    </div>
                </div>
                <div className="form-group col-md-12">
                    <label className="col-md-2">
                        {t("address")}
                    </label>
                    <div className="col-md-10">
                        <label className="form-control form-detail">{objectDto.poAddress}</label>
                    </div>
                </div>
                <div className="form-group col-md-12" style={{}}>
                    <label className="col-md-2" style={{ fontWeight: "bold", color: "red" }}>
                        {t("policypremium")}
                    </label>
                    <div className="col-md-4">
                        <input type="text" className="j-required " value={objectDto.premium}
                            onChange={(e) => setObjectDto({ ...objectDto, premium: e.target.value })}
                            style={{ fontWeight: "bold", color: "red", textAlign: "right" }}
                            onfocus="use_number(this)" onblur="use_text(this)" />
                        <span id="premium-text" style={{ fontWeight: "bold", color: "red", textAlign: "right" }}>đồng</span>
                    </div>
                    <label className="col-md-2" style={{ fontWeight: "bold", color: "red" }}>
                        {t("policypaidToDate")}
                    </label>
                    <div className="col-md-4">
                        <label className="form-control form-detail" style={{ fontWeight: "bold", color: "red" }} >{objectDto.paidToDate}</label>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="col-md-2" />
                    <div className="col-md-10">
                        <span id="" style={{ fontStyle: "italic", color: "red" }}>{t("paymentpremiumnote1")}</span>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="col-md-2" />
                    <div className="col-md-10">
                        <span id="" style={{ fontStyle: "italic", color: "red" }}>{t("paymentpremiumnote2")}</span>
                    </div>
                </div>
                {/* submit Div	 */}
                <div className="footer-box-bg col-md-12 form-group" style={{ display: "block" }} id="submitDiv">
                    <a id="btnPrev" className="btn-common btn-search">
                        {" "}
                        <i className="fa fa-arrow-left" aria-hidden="true" style={{ marginRight: 5 }} />
                        <span>{t("buttonprevious")}</span>
                    </a>{" "}
                    {
                        objectDto.premium !== 0 ?
                            <a id="btnPayment" className="btn-green btn-common" if="*{premium != 0}">
                                {" "} <i className=" fa fa-shopping-cart" />{" "} <span>{t("payment")}</span>
                            </a>
                            :
                            <a id="btnPayment" className="btn-green btn-common disable" if="*{premium == 0}">
                                {" "} <i className=" fa fa-shopping-cart" /> <span>{t("payment")}</span>
                            </a>
                    }
                    {" "}
                </div>
            </fieldset>
        </div>
    )
};
